import { render, staticRenderFns } from "./InputLanguageDropdown.vue?vue&type=template&id=db33f308"
import script from "./InputLanguageDropdown.vue?vue&type=script&lang=js"
export * from "./InputLanguageDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports